module.exports = __webpack_public_path__ + "static/media/Icons-nav-settings.157a167a.svg";